import { useState } from "react";
import type { BaseViewModel } from "../viewmodel/base.viewmodel";
import { useDidMount } from "./use-did-mount.hook";
import { useWillUnmount } from "./use-will-unmount.hook";

export const useViewModel = <T extends BaseViewModel>(
    viewModel: () => T,
): T => {
    const [instance] = useState<T>(() => viewModel());

    useDidMount(async () => {
        await instance.didMount?.();
    });

    useWillUnmount(() => {
        instance.willUnmount();
    });

    return instance;
};
